import { Label } from '@components/atoms';
import Input from '@components/atoms/Input/Input';
import type { User } from 'types/UserZendesk';

interface FormData {
  formData: {
    cpf_3: string;
    name: string;
    phone: string;
    email: string;
    errorEmail?: string | null;
    existUserEmail?: User | null;
  };
  error: string | null;
  isChecking: boolean;
  existUser: User | null;
  urlZaf: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  errorEmail: string | null;
  existUserEmail: User | null;
  typeUser: User[] | null;
}

export function FormUser({
  formData,
  error,
  isChecking,
  existUser,
  urlZaf,
  handleChange,
  errorEmail,
  existUserEmail,
  typeUser
}: FormData) {
  return (
    <form className="space-y-4 mt-4">
      <div>
        <Label title="CPF" />
        <Input name="cpf_3" type="text" value={formData.cpf_3} onChange={handleChange} disabled={typeUser && typeUser[0].role !== 'admin' ? true : false} />
        {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
        {isChecking && <p className="text-gray-500 text-sm mt-1">Verificando...</p>}
        {existUser && (
          <p className="text-gray-500 text-sm mt-1">
            Usuário encontrado:{' '}
            <a
              href={`${urlZaf}/users/${existUser.id}`}
              target="_blank"
              className="text-blue-600 underline text-sm mt-1"
            >
              {existUser.name}
            </a>
          </p>
        )}
      </div>

      <div>
        <Label title="Nome" />
        <Input name="name" type="text" value={formData.name} onChange={handleChange} />
      </div>

      <div>
        <Label title="Telefone" />
        <Input name="phone" type="text" value={formData.phone} onChange={handleChange} />
      </div>

      <div>
        <Label title="E-mail" />
        <Input name="email" type="email" value={formData.email} onChange={handleChange} />
        {errorEmail && <p className="text-red-500 text-sm mt-1">{errorEmail}</p>}
        {isChecking && <p className="text-gray-500 text-sm mt-1">Verificando...</p>}
        {existUserEmail && (
          <p className="text-gray-500 text-sm mt-1">
            Usuário encontrado:{' '}
            <a
              href={`${urlZaf}/users/${existUserEmail.id}`}
              target="_blank"
              className="text-blue-600 underline text-sm mt-1"
            >
              {existUserEmail.name}
            </a>
          </p>
        )}
      </div>
    </form>
  );
}
